import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=271338a6&scoped=true&"
import script from "./ChatForm.vue?vue&type=script&lang=js&"
export * from "./ChatForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=271338a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../tomokit-guest-app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271338a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../tomokit-guest-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
